export default "__VITE_ASSET__G$Gkc1Nr__"